'use client';

import { c as _c } from "react/compiler-runtime";
import { Download, Loader2 } from 'lucide-react';
import { RelatedFileType } from '@/types/file';
import { formatFileSize, textLimit } from '@/lib/utils';
import ContentFileIcon from './content-file-icon';
import { useFileDownload } from '@/hooks';
type PropsType = {
  files: RelatedFileType[];
  title?: string;
  size?: 'sm' | 'default';
  className?: string;
  itemsClassName?: string;
};
const ContentFiles = t0 => {
  const $ = _c(22);
  const {
    files,
    title: t1,
    size: t2,
    className: t3,
    itemsClassName: t4
  } = t0;
  const title = t1 === undefined ? "" : t1;
  const size = t2 === undefined ? "default" : t2;
  const className = t3 === undefined ? "" : t3;
  const itemsClassName = t4 === undefined ? "" : t4;
  const {
    mutate: downloadFile,
    isPending,
    variables
  } = useFileDownload();
  if (!files || files.length === 0) {
    return null;
  }
  let t5;
  if ($[0] !== downloadFile) {
    t5 = file => {
      downloadFile({
        fileId: file.id,
        fileName: file.name
      });
    };
    $[0] = downloadFile;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const handleDownload = t5;
  const t6 = `space-y-4 ${className}`;
  let t7;
  if ($[2] !== title) {
    t7 = title && <h3 className="text-xl font-semibold">{title}</h3>;
    $[2] = title;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = `grid grid-cols-1 gap-4 sm:grid-cols-2 ${size === "sm" ? "lg:grid-cols-2" : "lg:grid-cols-3"} ${itemsClassName}`;
  let t9;
  if ($[4] !== files || $[5] !== handleDownload || $[6] !== isPending || $[7] !== size || $[8] !== variables?.fileId) {
    let t10;
    if ($[10] !== handleDownload || $[11] !== isPending || $[12] !== size || $[13] !== variables?.fileId) {
      t10 = (item, index) => {
        const isDownloading = isPending && variables?.fileId === item.file.id;
        return <div key={index} onClick={() => !isDownloading && handleDownload(item.file)} className={`group flex items-center border border-gray-200 bg-white transition-all duration-300 ${size === "sm" ? "gap-2 rounded-md p-1.5" : "gap-3 rounded-lg p-4"} ${isDownloading ? "cursor-wait opacity-70" : `hover:border-brand cursor-pointer ${size === "sm" ? "hover:shadow-sm" : "hover:shadow-md"}`}`}><div className={`${size === "sm" ? "h-6 w-5" : "h-10 w-9"} shrink-0`}><ContentFileIcon file={item.file} /></div><div className="min-w-0 flex-1"><p className={`truncate font-medium ${size === "sm" ? "text-sm" : "text-md"}`}>{textLimit(item.file.name, 25)}</p><p className={`text-muted-foreground ${size === "sm" ? "text-xs" : "text-sm"}`}>{formatFileSize(item.file.size)}</p></div>{isDownloading ? <Loader2 className="text-brand h-5 w-5 shrink-0 animate-spin" /> : <Download className="group-hover:text-brand h-5 w-5 shrink-0 text-gray-400 transition-colors" />}</div>;
      };
      $[10] = handleDownload;
      $[11] = isPending;
      $[12] = size;
      $[13] = variables?.fileId;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    t9 = files.map(t10);
    $[4] = files;
    $[5] = handleDownload;
    $[6] = isPending;
    $[7] = size;
    $[8] = variables?.fileId;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t7) {
    t11 = <div className={t6}>{t7}{t10}</div>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default ContentFiles;